export const customerKeyMap = {
  sps: "x_studio_sps_vendor_number",
  markettime: "x_studio_mt_retailer_id",
  spsCamel: "xStudioSpsVendorNumber",
  markettimeCamel: "xStudioMtRetailerId",
};

export const addressKeyMap = {
  sps: "x_studio_sps_location_number",
  markettime: "x_studio_mt_address_id",
  spsCamel: "xStudioSpsLocationNumber",
  markettimeCamel: "xStudioMtAddressId",
};
